import { mortgageAPI } from "../services/MortgageAPI";
import AllMortgageListModel from "../model/AllMortgageListModel";

class MortgageService {
    mortgageCompany = async() : Promise<AllMortgageListModel[]> => {

        const mortgageList = await mortgageAPI.getAllMortgageCompanies();
        return mortgageList;
    }

    mortgageCompanyByInterestType = async (interestTypeId?: string): Promise<any[]> => {
        const mortgageList = await mortgageAPI.getAllMortgageCompaniesAsync(interestTypeId);
        return mortgageList;
    }
}

export const mortgageService = new MortgageService();